export default __webpack_public_path__ + "static/media/04_RoweOil-Commercial-EschweilerPhotography_M1A0150_flat_Shadows.61304dc5.jpg";